export default {"src":"/_next/static/media/ucp.46ed1d45.svg","height":229,"width":193,"blurWidth":0,"blurHeight":0};